// extracted by mini-css-extract-plugin
module.exports = {"controllsWrapper":"UserRights_controllsWrapper__1emJp","tableWrapper":"UserRights_tableWrapper__2vEQp","wrapper":"UserRights_wrapper__1thJH"};